if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
      }

      hide(preventFocus = false) {
        document.removeEventListener('click', this.handleOutsideClick);
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            this.setupColorSwatchSelector(); // Add color swatch functionality
            this.displayFirstSwatchImage(); // Display the first swatch's image on load
            super.show(opener);

            document.addEventListener('click', this.handleOutsideClick);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleOutsideClick(event) {
        if (!this.modalContent.contains(event.target) && !this.contains(event.target)) {
          this.hide();
        }
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      setupColorSwatchSelector() {
        const colorSwatches = this.modalContent.querySelectorAll('[id^="swatch-fieldset-quickadd"] input[type="radio"]');
        
        if (colorSwatches.length > 0) {
          console.log("Color swatches detected:", colorSwatches.length);

          colorSwatches.forEach(swatch => {
            swatch.addEventListener('change', () => {
              this.displayImageForSwatch(swatch);
            });
          });
        } else {
          console.log("No color swatches found in the modal.");
        }
      }

      displayImageForSwatch(swatch) {
        let selectedColor = swatch.value.toLowerCase();
        console.log("Original swatch value:", selectedColor);

        // Extract the part before the first hyphen and convert spaces to underscores
        selectedColor = selectedColor.split('-')[0].trim().replace(/\s+/g, '_');
        console.log("Transformed swatch value for matching:", selectedColor);
        

        // Hide all items in the media gallery initially
        const galleryItems = this.modalContent.querySelectorAll('.product__media-list .product__media-item img');
        galleryItems.forEach(item => item.closest('.product__media-item').style.display = 'none');

        // Display only the first matching image based on the transformed color name
        let foundMatch = false;

        for (const item of galleryItems) {
          const imageSrc = item.src.toLowerCase();
          if (imageSrc.includes(selectedColor)) {
            item.closest('.product__media-item').style.display = 'block'; // Show first matching item
            console.log(`Displaying first matching item with image URL: ${imageSrc}`);
            foundMatch = true;
            break;
          }
        }

        if (!foundMatch) {
          console.warn(`No matching images found for transformed color: ${selectedColor}`);
        }
      }

      displayFirstSwatchImage() {
        const firstSwatch = this.modalContent.querySelector('[id^="swatch-fieldset-quickadd"] input[type="radio"]');
        if (firstSwatch) {
          this.displayImageForSwatch(firstSwatch);
        } else {
          console.warn("No swatch available to display initially.");
        }
      }
    }
  );
}
